import {Component, EventEmitter, Input, Output} from '@angular/core';

import {AbstractSerialBadgeType} from 'shared/models/badges/abstract-serial-badge-type';
import { MorningImpulseBadgeType } from 'shared/models/badges/morning-impulse-badge-type';

@Component({
  selector: 'type-serial',
  templateUrl: './type-serial.component.html',
  styleUrls: ['./type-serial.component.css'],
})
export class TypeSerialComponent {

  @Input() public language: string;
  @Input() public data: AbstractSerialBadgeType;
  @Input() public active: boolean;
  @Output() public dataChange: EventEmitter<AbstractSerialBadgeType>;

  constructor() {
    this.data = new MorningImpulseBadgeType(); // TODO
    this.dataChange = new EventEmitter<AbstractSerialBadgeType>();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/type-components/type-serial/type-serial.component.ts